import { JobCardSkeletonList } from "@/components/common/skeletons";

export function JobsLoadingState() {
  return <JobCardSkeletonList count={3} />;
}